export const ADDING_AUTHORIZATION_HEADER_WITH_BEARER_TOKEN = '0';
export const AUDIENCE_EVALUATION_RESULT = '1';
export const CMAB_CACHE_ATTRIBUTES_MISMATCH = '2';
export const CMAB_CACHE_HIT = '3';
export const CMAB_CACHE_MISS = '4';
export const EVALUATING_AUDIENCE = '5';
export const FAILED_TO_PARSE_REVENUE = '6';
export const FAILED_TO_PARSE_VALUE = '7';
export const FEATURE_ENABLED_FOR_USER = '8';
export const FEATURE_NOT_ENABLED_FOR_USER = '9';
export const FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE = '10';
export const IGNORE_CMAB_CACHE = '11';
export const INVALIDATE_CMAB_CACHE = '12';
export const INVALID_CLIENT_ENGINE = '13';
export const INVALID_DECIDE_OPTIONS = '14';
export const INVALID_DEFAULT_DECIDE_OPTIONS = '15';
export const INVALID_EXPERIMENT_KEY_INFO = '16';
export const MAKING_DATAFILE_REQ_TO_URL_WITH_HEADERS = '17';
export const MISSING_ATTRIBUTE_VALUE = '18';
export const NOT_ACTIVATING_USER = '19';
export const PARSED_NUMERIC_VALUE = '20';
export const PARSED_REVENUE_VALUE = '21';
export const RESET_CMAB_CACHE = '22';
export const RESPONSE_STATUS_CODE = '23';
export const SAVED_LAST_MODIFIED_HEADER_VALUE_FROM_RESPONSE = '24';
export const SAVED_USER_VARIATION = '25';
export const SAVED_VARIATION_NOT_FOUND = '26';
export const SHOULD_NOT_DISPATCH_ACTIVATE = '27';
export const SKIPPING_JSON_VALIDATION = '28';
export const TRACK_EVENT = '29';
export const UNEXPECTED_TYPE_NULL = '30';
export const UPDATED_OPTIMIZELY_CONFIG = '31';
export const USER_HAS_NO_FORCED_VARIATION = '32';
export const USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT = '33';
export const USER_MAPPED_TO_FORCED_VARIATION = '34';
export const USER_RECEIVED_DEFAULT_VARIABLE_VALUE = '35';
export const USER_RECEIVED_VARIABLE_VALUE = '36';
export const VALID_BUCKETING_ID = '37';
export const VALID_DATAFILE = '38';
export const VALID_USER_PROFILE_SERVICE = '39';
export const VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE = '40';
export const VARIATION_REMOVED_FOR_USER = '41';
export const messages = [
    "Adding Authorization header with Bearer Token",
    "Audience \"%s\" evaluated to %s.",
    "CMAB cache attributes mismatch for user %s and rule %s, fetching new decision.",
    "Cache hit for user %s and rule %s.",
    "Cache miss for user %s and rule %s.",
    "Starting to evaluate audience \"%s\" with conditions: %s.",
    "Failed to parse revenue value \"%s\" from event tags.",
    "Failed to parse event value \"%s\" from event tags.",
    "Feature %s is enabled for user %s.",
    "Feature %s is not enabled for user %s.",
    "Feature \"%s\" is not enabled for user %s. Returning the default variable value \"%s\".",
    "Ignoring CMAB cache for user %s and rule %s.",
    "Invalidating CMAB cache for user %s and rule %s.",
    "Invalid client engine passed: %s. Defaulting to node-sdk.",
    "Provided decide options is not an array. Using default decide options.",
    "Provided default decide options is not an array.",
    "Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
    "Making datafile request to url %s with headers: %s",
    "Audience condition %s evaluated to UNKNOWN because no value was passed for user attribute \"%s\".",
    "Not activating user %s for experiment %s.",
    "Parsed event value \"%s\" from event tags.",
    "Parsed revenue value \"%s\" from event tags.",
    "Resetting CMAB cache for user %s and rule %s.",
    "Response status code: %s",
    "Saved last modified header value from response: %s",
    "Saved user profile for user \"%s\".",
    "User %s was previously bucketed into variation with ID %s for experiment %s, but no matching variation was found.",
    "Experiment %s is not in \"Running\" state. Not activating user.",
    "Skipping JSON schema validation.",
    "Tracking event %s for user %s.",
    "Audience condition %s evaluated to UNKNOWN because a null value was passed for user attribute \"%s\".",
    "Updated Optimizely config to revision %s (project id %s)",
    "User %s is not in the forced variation map.",
    "No experiment %s mapped to user %s in the forced variation map.",
    "Set variation %s for experiment %s and user %s in the forced variation map.",
    "User \"%s\" is not in any variation or rollout rule. Returning default value for variable \"%s\" of feature flag \"%s\".",
    "Got variable value \"%s\" for variable \"%s\" of feature flag \"%s\"",
    "BucketingId is valid: \"%s\"",
    "Datafile is valid.",
    "Valid user profile service provided.",
    "Variable \"%s\" is not used in variation \"%s\". Returning default value.",
    "Variation mapped to experiment %s has been removed for user %s."
];
//# sourceMappingURL=log_message.gen.js.map